/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/scroll-up': {
    width: 26,
    height: 18,
    viewBox: '0 0 26 18',
    data: '<path pid="0" d="M13 0l12.124 17.25H.876L13 0z" _fill="#000"/>'
  }
})
